import { BasicDialogProperties } from "../../../../basic/view/dialogs/BasicDialogProperties";

import { BasicModel } from "@goodgamestudios/core";

export class Poker2JoinSitnGoDialogProperties extends BasicDialogProperties {
    public buttonLabel_yes: string = "Yes";
    public buttonLabel_no: string = "No";
    public copy: string = "";
    public title: string = "";
    public functionYes: Function;
    public functionNo: Function;
    public functionClose: Function;
    public sitnGoId: number = NaN;

    constructor(title: string, copy: string, sitnGoId: number, functionYes: Function = null, functionNo: Function = null, functionClose: Function = null, buttonLabel_yes: string = "", buttonLabel_no: string = "") {
        super();

        this.functionClose = functionClose;
        this.functionYes = functionYes;
        this.functionNo = functionNo;
        this.sitnGoId = sitnGoId;

        if (buttonLabel_yes.length > 0)
            this.buttonLabel_yes = buttonLabel_yes;
        else
            this.buttonLabel_yes = BasicModel.languageData.getTextById("generic_btn_yes");

        if (buttonLabel_no.length > 0)
            this.buttonLabel_no = buttonLabel_no;
        else
            this.buttonLabel_no = BasicModel.languageData.getTextById("generic_btn_no");

        this.title = title;
        this.copy = copy;
    }
}
